// account.js — Einträge des Konto-Menüs (rein). Die Bereiche kommen fertig vom Server (/api/me → areas, lib/areas.js).
import { t } from './i18n.js';

/** Verwaltung öffnet in einem eigenen Tab (Arbeitsbereich neben der App, seit v395). */
export const newTab = (a) => a && a.id === 'admin';

/** Menü-Einträge für openMenu(): Kopf (Name), Bereiche, Profil, Abmelden. current = id des Bereichs, in dem man gerade ist. */
export function accountItems(me, { current, profileUrl, languages }) {
  const head = (me && (me.name || me.email)) || '';
  const areas = (me && Array.isArray(me.areas) ? me.areas : []).map((a) => ({
    value: a.url, label: t('ui.area_' + a.key), icon: a.icon, current: a.id === current, newTab: newTab(a) && a.id !== current,
  }));
  return [
    ...(head ? [{ group: head }] : []),
    ...areas,
    { divider: true },
    // Sprache: überall dort, wo die Seite ihre Sprachen kennt — die Verwaltung bleibt deutsch
    ...(languages && Array.isArray(languages.aktiv) && languages.aktiv.length > 1 && current !== 'admin'
      ? [{ value: '#lang', label: t('ui.acct_language', { name: (languages.aktiv.find((l) => l.code === languages.lang) || {}).name || languages.lang }), icon: 'language' }] : []),
    { value: profileUrl, label: t('ui.acct_profile'), icon: 'manage_accounts' },
    { value: '/auth/logout', label: t('ui.acct_logout'), icon: 'logout' },
  ];
}

/** Ein bis zwei Buchstaben für den Avatar ohne Bild. */
export function initials(me) {
  const src = String((me && (me.name || me.email)) || '').trim();
  if (!src) return '?';
  const words = (me.name ? src.split(/\s+/) : [src]).filter(Boolean);
  return words.slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}

/** Einträge der Sprachauswahl: „Automatisch“ (Browser) und die aktiven Sprachen; markiert ist die aktuelle Wahl. */
export function languageItems(languages) {
  const cur = languages && languages.manuell ? languages.lang : 'auto';
  return [{ value: 'auto', label: t('ui.acct_lang_auto'), current: cur === 'auto' },
    ...((languages && languages.aktiv) || []).map((l) => ({ value: l.code, label: l.name, lang: l.code, current: cur === l.code }))];
}
